import { render, staticRenderFns } from "./PayableReceivableSummary.vue?vue&type=template&id=6af48326&scoped=true&"
import script from "./PayableReceivableSummary.vue?vue&type=script&lang=js&"
export * from "./PayableReceivableSummary.vue?vue&type=script&lang=js&"
import style0 from "./PayableReceivableSummary.vue?vue&type=style&index=0&id=6af48326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af48326",
  null
  
)

export default component.exports